import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
export const fetchEventProcedures = async (page, perPage, query = null, orderBy = void 0, direction = void 0) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (orderBy) {
    params.push(`sort=${orderBy}`);
  }
  if (direction) {
    params.push(`direction=${direction}`);
  }
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.index(params.join("&")).url));
};
export const fetchEventProcedure = async (eventProcedureId) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.singleEventProcedure(eventProcedureId).url));
export const fetchDecoratedEventProcedure = async (eventProcedureId, eventId) => fetch(
  "GET",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.decoratedEventProcedure(eventProcedureId, eventId).url)
);
export const createEventProcedure = async (payload) => {
  const { share_request, ...rest } = payload;
  return fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.new().url), {
    entity: rest,
    share_request
  });
};
export const updateEventProcedure = async ({
  eventProcedureId,
  eventProcedure
}) => fetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.singleEventProcedure(eventProcedureId).url),
  eventProcedure
);
export const fetchEventProcedureSteps = async (page, perPage, query = null, orderBy = void 0, direction = void 0) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (orderBy) {
    params.push(`sort=${orderBy}`);
  }
  if (direction) {
    params.push(`direction=${direction}`);
  }
  return fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.index(params.join("&")).url));
};
export const createEventProcedureStep = async (payload) => {
  const { share_request, ...rest } = payload;
  return fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.new().url), {
    entity: rest,
    share_request
  });
};
export const updateEventProcedureStep = async ({ stepId, step }) => fetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.singleEventProcedureStep(stepId).url),
  step
);
export const deleteEventProcedure = async ({ id }) => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.singleEventProcedure(id).url));
export const fetchLinkedProcedures = async (stepId) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.linkedProcedures(stepId).url));
export const deleteEventProcedureStep = async ({ id }) => fetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.singleEventProcedureStep(id).url));
export const fetchParametersForView = async (id, type) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.viewParameter(id, type).url));
export const executeEventProcedureActionBulk = async ({
  stepId,
  eventIds
}) => fetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.executeActionBulk().url), {
  step_id: stepId,
  event_ids: eventIds
});
